export function shouldRedirectToCanonicalOfferUrl(
  offer: Pick<App.Offer, 'slug'>,
  offerSlug: string | undefined,
  propertyPageOfferId: string | undefined,
): boolean {
  return !propertyPageOfferId && offer.slug !== offerSlug
}
